import { useMutation } from 'react-query'

import { sendWhatsappMessage } from '~services/evaluations.service'

export const useSendWhatsappLinkMutation = () => {
  return useMutation(sendWhatsappMessage)
}
